<template>
  <div class="date-search-global">
    <b-dropdown
      aria-role="menu"
      expanded
      append-to-body
      :close-on-click="false"
    >
      <template #trigger>
        <div
          class="input-search-2 adjust-input-clients border-radius-5 input-date-wrapper cursor-pointer"
        >
          <div class="is-flex is-align-items-center pr-4">
            <CalendarIcon class="flex-shrink-0" color="#252525" size="14" />
            <p class="ml-1 white-space-nowrap">{{ renderDate }}</p>
          </div>
        </div>
      </template>
      <div class="dropdown-specific-wrapper">
        <v-date-picker
          v-model="selectedDate"
          mode="date"
          is-expanded
          is-range
          color="red"
        />
      </div>
    </b-dropdown>
    <button
      v-if="selectedDate"
      class="delete xmark-button"
      @click="clearSelectedDate"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'DropdownDateSearchGlobal',
  components: {
    CalendarIcon: () => import('@/components/icons/CalendarIcon')
  },
  computed: {
    ...mapGetters({
      tabPersist: 'list/getPersistTabProject'
    }),
    renderDate () {
      let value = 'Tanggal Bayar'
      if (this.selectedDate) {
        const { start, end } = this.selectedDate
        if (start.toString() === end.toString()) {
          value = moment(start).format('DD/MM/YYYY')
        } else {
          value = `${moment(start).format('DD/MM/YYYY')} - ${moment(end).format(
            'DD/MM/YYYY'
          )}`
        }
      }
      return value
    }
  },
  data () {
    return {
      selectedDate: null
    }
  },
  methods: {
    clearSelectedDate () {
      this.selectedDate = null
    }
  },
  mounted () {
    const getDate = localStorage.getItem('filter_date_search_global')
    if (JSON.parse(getDate)) {
      this.selectedDate = JSON.parse(getDate)
    }
  },
  watch: {
    selectedDate (val) {
      localStorage.setItem('filter_date_search_global', JSON.stringify(val))
      this.$store.commit('project/setDateSearchGlobal', val)
    }
  }
}
</script>

<style scoped lang="scss">
.date-search-global {
  position: relative;
  width: 100%;
}

.dropdown-specific-wrapper {
  position: relative;
  width: 18em;
  z-index: 5;
  transform: scale(1.055);
}

.input-date-wrapper {
  padding: 7px 9px;
}

.xmark-button {
  zoom: 0.7;
  position: absolute;
  right: 8px;
  top: 18px;
}
</style>

<style>
.date-search-global .dropdown-content {
  padding: 0 !important;
}
</style>
